import { CheckUtils, CustomFieldDefinitionVoData } from "../..";
import { CustomFieldValueConverter } from "./custom-field-value-converter";
var CustomFieldDefinitionConverter = /** @class */ (function () {
    function CustomFieldDefinitionConverter() {
    }
    CustomFieldDefinitionConverter.convertToCustomFieldDefinitionVoData = function (customFieldDefinitionMap) {
        var customFieldDefinitionsVoData = [];
        if (!CheckUtils.isEmpty(customFieldDefinitionMap) && customFieldDefinitionMap instanceof Map) {
            customFieldDefinitionMap.forEach(function (definition, key) {
                var customFieldDefinitionVoData = new CustomFieldDefinitionVoData(definition.id);
                customFieldDefinitionVoData.defaultValue = definition.defaultValue;
                customFieldDefinitionVoData.name = definition.name;
                customFieldDefinitionVoData.type = definition.type;
                customFieldDefinitionVoData.values = CustomFieldValueConverter.convertToCustomFieldValueVoDataArray(definition.values);
                customFieldDefinitionsVoData.push(customFieldDefinitionVoData);
            });
        }
        return customFieldDefinitionsVoData;
    };
    return CustomFieldDefinitionConverter;
}());
export { CustomFieldDefinitionConverter };
//# sourceMappingURL=custom-field-definition-converter.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/utils/converter/custom-field-definition-converter.js
// module id = 968
// module chunks = 14